import {
	getAction
} from '@/api/index';
import axios from 'axios';
import {
	SVG
} from '@svgdotjs/svg.js';
import {
	mapGetters
} from 'vuex'
export default {
	data() {
		return {
			url: {
				parkAreaSetting: '/officialWebsite/c-api/setting/parkArea',
				companyProfileSetting: '/officialWebsite/c-api/setting/companyProfile',
				corporateCultureSetting: '/officialWebsite/c-api/setting/corporateCulture',
				corporateHonorsSetting: '/officialWebsite/c-api/setting/corporateHonors'
			},
			parkAreaSet: {},
			companyProfile: '',
			corporateCulture: '',
			corporateHonors: '',
			curCapsuleDialogStatus: {
				curIdx: -1,
				x: 0,
				y: 0,
				show: false,
				showDialog: false,
				timeOut: null,
				rootDomW: 0,
			}
		}
	},
	watch: {
		scaleRate: {
			handler(val, oldValue) {
				this.calcContentHeight();
				this.closeCapsuleDialog();
			},
			//立刻执行handler
			//immediate: true
		}
	},
	computed: {
		...mapGetters(["scaleRate","isVerticalScreen"]),
		_isMobile() {
		    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		    return flag;
		},
		popDialogBgStyle() {
			if(this.curCapsuleDialogStatus.rootDomW / 2 < this.curCapsuleDialogStatus.x) {
				return {
					transform: 'rotateY(180deg)'
				}
			}
			return {};
		},
		curArea() {
			if(this.curCapsuleDialogStatus.curIdx >= 0) {
				const item = this.parkAreaSet.itemSettings
					.filter(it => it.itemIdx == this.curCapsuleDialogStatus.curIdx)[0];
				if(item) {
					let str = '';
					if(item.coverImg) {
						str = "<img src='"+item.coverImg+"' width='100%' />";
					}
					if(item.profileInf) {
						str = str + item.profileInf;
					}
					return {...item, popContent: str};
				}
			}
			return {}
		},
		capsuleArrowRight() {
			return this.curArea.popContent 
					|| this.areaCanJump;
		},
		areaCanJump() {
			return (this.curArea.jumpType == 0 && this.curArea.innerContent)
					|| (this.curArea.jumpType == 1 && this.curArea.outerUrl);
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.loadParkAreaSetting();
			this.loadAboutMeSetting();
		},
		async loadParkAreaSetting() {
			const res = await getAction(this.url.parkAreaSetting);
			if (res.success) {
				this.parkAreaSet = res.result;
				this.initSvg();
			}
		},
		async loadAboutMeSetting() {
			const res = await getAction(this.url.companyProfileSetting);
			const res2 = await getAction(this.url.corporateCultureSetting);
			const res3 = await getAction(this.url.corporateHonorsSetting);
			if (res.success && res2.success && res3.success) {
				this.companyProfile = res.result;
				this.corporateCulture = res2.result;
				this.corporateHonors = res3.result;
				this.calcContentHeight();
			}
		},
		calcContentHeight() {
			this.$nextTick(() => {
				let doms = document.getElementsByClassName('auto-height');
				for (let i = 0; i < doms.length; i++) {
					doms[i].style.height =
						(doms[i].getElementsByClassName('calc-line')[0].getBoundingClientRect().height) + 'px';
				}
			});
		},
		initSvg() {
			const dom = document.querySelector(".svg-box");
			dom.innerHTML = "";
			// 对SVG图进行异步渲染
			return new Promise((resolve, reject) => {
				let draw = SVG()
					.addTo(".svg-box") // 要渲染的区域
					.size("100%", "100%"); // 大小
				//if(!this._isMobile) {
				//	draw.translate(this.parkAreaSet.offsetX || 0, this.parkAreaSet.offsetY || 0)
				//	.scale(this.parkAreaSet.scaleRate || 1, this.parkAreaSet.scaleRate || 1); // 比例
				//}	
				draw.style('transform: matrix(3,0,0,3,-1,-14)')
				axios.get(this.parkAreaSet.areaImgUrl).then((res) => {
					draw.svg(res.data);
					setTimeout(() => {
						this.addAction();
						this.addTransform();
					}, 100);
					resolve("success");
				});
			});
		},
		addTransform() {
			const dom = document.querySelector('.svg-box');
			if(!dom) return;
			const domRoot = dom.children[0];
			if(!domRoot) return;
			domRoot.style.transform = 'matrix('+(this.parkAreaSet.scaleRate || 1)
				+',0,0,'+(this.parkAreaSet.scaleRate || 1)+','+(this.parkAreaSet.offsetX || 0)
				+','+(this.parkAreaSet.offsetY || 0)+')';
		},
		addAction() {
			const dom = document.querySelector('.svg-box');
			if (!dom) return;
			const svgElems = dom.querySelectorAll('rect,polygon');
			this.parkAreaSet.itemSettings.forEach(it => {
				const item = svgElems[it.itemIdx];
				if(this._isMobile) {
					if(it.promptText) {
						item.addEventListener('click', (e) => {
							//console.log('click', e)
							e.stopPropagation();
							this.closeCapsuleDialog();
							this.onMouseoverArea(dom, item, it.itemIdx);
							this.onClickCapsule();
						});
					}
				}else {
					if(it.promptText) {
						item.addEventListener('mousemove', (e) => {
							this.onMouseoverArea(dom, item, it.itemIdx);
						});
					}
					item.addEventListener('mouseout', (e) => {
						this.onMouseoutArea();
					});
				}
				
			})
		},
		onMouseoverArea(rootDom, item, idx) {
			if(this.curCapsuleDialogStatus.showDialog) return;
			const rootX = rootDom.getBoundingClientRect().left;
			const rootY = rootDom.getBoundingClientRect().top;
			console.log('rootX', rootX)
			this.curCapsuleDialogStatus.rootDomW = rootDom.getBoundingClientRect().width;
			const rect = item.getBoundingClientRect();
			if(idx != this.curCapsuleDialogStatus.curIdx) {
				this.$set(this.curCapsuleDialogStatus, 'curIdx', idx);
				this.curCapsuleDialogStatus.show = true;
				this.curCapsuleDialogStatus.showDialog = false;
				this.curCapsuleDialogStatus.x = rect.left - rootX + rect.width / 2 - 10 * this.scaleRate;
				this.curCapsuleDialogStatus.y = rect.top - rootY + rect.height / 2 - 15 * this.scaleRate;
			}
			//console.log('mouseover',JSON.stringify(this.curCapsuleDialogStatus))
		},
		onMouseoutArea() {
			if(this.curCapsuleDialogStatus.timeOut) {
				clearTimeout(this.curCapsuleDialogStatus.timeOut)
			}
			if(this.curCapsuleDialogStatus.showDialog) return;
			this.curCapsuleDialogStatus.timeOut = setTimeout(() => {
				this.closeCapsuleDialog();
			}, 500);
		},
		closeCapsuleDialog() {
			this.curCapsuleDialogStatus.show = false;
			this.curCapsuleDialogStatus.showDialog = false;
			this.curCapsuleDialogStatus.curIdx = -1;
		},
		onHoldCapsuleDialog() {
			if(this.curCapsuleDialogStatus.timeOut) {
				clearTimeout(this.curCapsuleDialogStatus.timeOut)
			}
		},
		onClickCapsule() {
			if(!this.capsuleArrowRight) return;
			if(this.curArea.popContent) {
				this.curCapsuleDialogStatus.showDialog = true;
				setTimeout(() => {
					this.calcContentHeight();
				}, 100);
			}else {
				this.jumpTo();
				this.closeCapsuleDialog();
			}
		},
		jumpTo() {
			if(this.curArea.jumpType == 0 && this.curArea.innerContent) {
				this.$router.push({
					path: '/detail?type=aboutMe&id=' + this.curArea.itemIdx
				});
			}else if(this.curArea.jumpType == 1 && this.curArea.outerUrl) {
				const id = 'url_about_me'+this.curArea.itemIdx;
				var a = document.createElement('a');
				a.setAttribute('href', this.curArea.outerUrl);
				a.setAttribute('target', '_blank');
				a.setAttribute('id', id);
				// 防止反复添加
				if(!document.getElementById(id)) document.body.appendChild(a);
				a.click();
				document.getElementById(id).remove();
			}
		},
		onClickPopDialog() {
			if(!this.areaCanJump) return;
			this.jumpTo();
			this.closeCapsuleDialog();
		}
	}
}